import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getImage } from '@utils/imageHelper';
import { NTA_HEADER_TITLES, NTA_HEADER_VARIANT } from '../../constants';
import NtaHeaderLanguageSelect from './NtaHeaderLanguageSelect';
import NtaHeaderUserInfo from './NtaHeaderUserInfo';
import {
  HeaderRoot,
  LogoImg,
  Title,
  TitleBar,
  TitleBarEnd,
  TopBar,
  TopBarEnd
} from './NtaHeader.styles';

const NtaHeader = ({
  variant = NTA_HEADER_VARIANT.INSTRUCTIONS,
  title,
  showTimer = true,
  onTimerExpire,
  languages,
  selectedLanguage,
  onLanguageChange,
  languageLabel,
  topBarEnd,
  titleBarEnd
}) => {
  const { query } = useRouter();
  const { quizUID } = query;
  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));

  const isTestVariant = variant === NTA_HEADER_VARIANT.TEST;
  const isInstructionsVariant = variant === NTA_HEADER_VARIANT.INSTRUCTIONS;

  const resolvedTitle =
    title ??
    (isInstructionsVariant
      ? NTA_HEADER_TITLES.GENERAL_INSTRUCTIONS
      : quizDetails?.title);

  const showLanguageSelect =
    isInstructionsVariant && languages?.length > 0 && !titleBarEnd;

  return (
    <HeaderRoot>
      <TopBar>
        <LogoImg src={getImage('logo.svg')} alt="Unacademy" />
        {(isTestVariant || topBarEnd) && (
          <TopBarEnd>
            {topBarEnd ??
              (isTestVariant && (
                <NtaHeaderUserInfo
                  showTimer={showTimer}
                  onTimerExpire={onTimerExpire}
                />
              ))}
          </TopBarEnd>
        )}
      </TopBar>
      <TitleBar>
        <Title>{resolvedTitle}</Title>
        {(showLanguageSelect || titleBarEnd) && (
          <TitleBarEnd>
            {titleBarEnd ??
              (showLanguageSelect && (
                <NtaHeaderLanguageSelect
                  languages={languages}
                  selectedLanguage={selectedLanguage}
                  onLanguageChange={onLanguageChange}
                  label={languageLabel}
                />
              ))}
          </TitleBarEnd>
        )}
      </TitleBar>
    </HeaderRoot>
  );
};

NtaHeader.propTypes = {
  variant: PropTypes.oneOf(Object.values(NTA_HEADER_VARIANT)),
  title: PropTypes.string,
  showTimer: PropTypes.bool,
  onTimerExpire: PropTypes.func,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      display_name: PropTypes.string
    })
  ),
  selectedLanguage: PropTypes.shape({
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    display_name: PropTypes.string
  }),
  onLanguageChange: PropTypes.func,
  languageLabel: PropTypes.string,
  topBarEnd: PropTypes.node,
  titleBarEnd: PropTypes.node
};

export default NtaHeader;
